import { createSlice } from '@reduxjs/toolkit';
import { Supplier } from 'src/types/supplier';
import * as thunks from './thunks';
import { PaginationV2 } from 'src/types';

type State = {
  suppliers: Supplier[];
  meta: PaginationV2;
};

const initialState: State = {
  suppliers: [],
  meta: {}
};

const slice = createSlice({
  name: 'suppliers',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(
      thunks.getSuppliersThunk.fulfilled,
      (state, { payload }) => {
        state.suppliers = payload?.originalData?.data || [];
        state.meta = payload?.originalData?.meta || {};
      }
    );
  }
});

export const reducer = slice.reducer;

export const actions = {
  ...slice.actions,
  ...thunks
};
